import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { RgpdProvider } from '../../../providers/rgpd/rgpd';


@Component({
  selector: 'page-rgpd',
  templateUrl: 'rgpd.html',
})
export class RGPDPage {
  activeSegment: string = '0';
  constructor(public navCtrl: NavController, public navParams: NavParams, private rgpdProvider: RgpdProvider, public viewCtrl: ViewController) {
  }

  isRequestSent:boolean = false;

  ionViewDidLoad() {
    console.log('ionViewDidLoad RGPD');
  }

  deleteDatasFromApp(){
    this.rgpdProvider.deleteDatasFromApp().subscribe((res) => {
      if(res.success){
        this.isRequestSent = true;
      }
    })
  }

  downloadDatas(){
    this.rgpdProvider.downloadRgpdReport().subscribe((res) => {
      if(res.success){
        this.isRequestSent = true;
      }
    })
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/employee/rgpd/rgpd.ts